import type { PropsWithChildren, ReactNode } from 'react';
import clsx from 'clsx';
import React from 'react';

type Props = PropsWithChildren<{
  isLeftNavExpanded: boolean;
  navigation: ReactNode;
  navigationFooter: ReactNode;
}>;

export const DashboardBodyLayout = ({
  isLeftNavExpanded,
  navigation,
  navigationFooter,
  children,
}: Props) => {
  const twTransition = 'transition-all duration-100 menu-transition';
  return (
    <>
      <div className="flex flex-col flex-1 min-h-0 relative z-0">
        <div
          className={clsx([
            isLeftNavExpanded ? 'px-f2' : 'pr-f2',
            'h-full overflow-auto flex flex-row',
            twTransition,
          ])}
        >
          <div
            className={clsx([
              'fixed laptop:absolute left-f0',
              isLeftNavExpanded
                ? 'w-f21 min-w-f21 max-w-f21'
                : 'w-[calc(2lh+1ch)] min-w-[calc(2lh+1ch)] max-w-[calc(2lh+1ch)]',
              'flex flex-col pl-f2 overflow-y-auto scrollbar-hide',
              'border-r-[0.5px] border-main-300',
              'pr-f2 pb-f6 h-full z-20 bg-canvas',
              'pt-f2',
              twTransition,
            ])}
          >
            {navigation}
          </div>
          <main
            data-testid="layout-main"
            className={clsx([
              'w-full h-full scrollbar-hide',
              isLeftNavExpanded
                ? 'laptop:grow laptop:pl-f19'
                : 'pl-[calc(2lh+1ch)]',
              twTransition,
            ])}
          >
            {children}
          </main>
        </div>
      </div>
      <div
        className={clsx(
          'absolute bottom-0 z-30 bg-canvas',
          'flex h-f6 flex-row items-center justify-start border-r-[0.5px] border-main-300 pl-f2',
          isLeftNavExpanded ? 'left-0 w-f21 pr-f2' : 'left-0 w-[calc(2lh+1ch)]',
          twTransition
        )}
        data-testid="account-menu-container"
      >
        {navigationFooter}
      </div>
    </>
  );
};
